import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Response } from '../models/response';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';

const baseUrl: string = `${environment.api}/projects/`;
const learnedLessonsUrl: string = `${environment.api}/learnedlessons/`;

@Injectable({
  providedIn: 'root'
})
export class ReflectionService {
  private readonly http: HttpClient = inject(HttpClient);

  constructor() {}

  editLesson(lesson: any): Observable<Response<any>> {
    return of({ result: lesson } as Response<any>);
  }

  deleteRiflessione(id: number) {
    return of({ result: null });
  }

  getMyReflectionsAfterLastReview(
    chosenUser?: string,
    selectedReviewId?: number | string
  ): Observable<any> {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    let params = new HttpParams();

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    if (selectedReviewId !== undefined) {
      params = params.set('review_id', selectedReviewId.toString());
    }

    return of({ result: [] });
  }

  getMyProjects(year: any, month: any, chosenUser?: string): Observable<any> {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    let params = new HttpParams().set('year', year).set('month', month);

    if (chosenUser) {
      params = params.set('chosen_user', chosenUser);
    }

    return this.http.get<any>(baseUrl + 'myProjects', {
      params: params,
      context: new HttpContext().set(CONFIG, config)
    });
  }
}
